import React, { useContext } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import TableContext from '../../TableContext';
import ActionMenuItem from './ActionMenuItem';
import actionMenuType from '../../type/actionMenu';

const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: theme.spacing(1)
  }
}));

const ActionMenu = ({ actions = [] }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { selected, clearSelected, data } = useContext(TableContext);
  const open = Boolean(anchorEl);

  if (selected.length === 0 || actions.length === 0) {
    return null;
  }

  const handleIconClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  function getSelectedData() {
    return data.filter(row => selected.includes(row.id));
  }

  const handleActionClick = action => {
    const selectedData = getSelectedData();
    action.onClick(selectedData, clearSelected);
    // clearSelected();
    closeMenu();
  };

  return (
    <div className={classes.container}>
      <IconButton
        aria-label="actions"
        aria-controls="action-menu"
        aria-haspopup="true"
        onClick={handleIconClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={closeMenu}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
      >
        {actions.map(action => (
          <ActionMenuItem
            label={action.label}
            onClick={() => handleActionClick(action)}
            key={action.label}
          />
        ))}
      </Menu>
    </div>
  );
};

ActionMenu.propTypes = actionMenuType;

export default ActionMenu;
